// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"5984f7c0","609":"a17ad1bb"}[chunkId] + ".chunk.css";
};